import React from 'react';

import NewsDetails from '../NewsDetails/NewsDetails';
import ActionButton from '../../../components/ActionButton/ActionButton';
import MoreNewsList from '../MoreNewsList/MoreNewsList';
import {
  ArticleDetailsContainer,
  BackButtonContainer,
  ContentContainer,
  MoreArticlesContainer,
  NewsPreviewContainer,
} from './styles';
import { NewsPreviewProps } from './types';
import { useI18n } from '../../../../hooks/useI18n';
import { TranslationKeys } from '../../../../i18n/locales/defaultResources';
import { useAppInsightsComponentLifetimeTracking } from '../../../../services/appInsights/useAppInsightsComponentTracking';

const NewsPreview: React.FC<NewsPreviewProps> = ({
  countryIsoCode,
  selectedArticle,
  relatedArticles,
  onBack,
  onReadMore,
  transitionClass,
}) => {
  const { t } = useI18n();

  useAppInsightsComponentLifetimeTracking(
    'NewsPreview',
    {
      newsTitle: selectedArticle?.title,
      newsId: selectedArticle?.guid,
    },
    [selectedArticle]
  );

  if (!selectedArticle) {
    return <div>{t(TranslationKeys.news_preview_no_article_selected)}</div>;
  }

  return (
    <NewsPreviewContainer className={transitionClass}>
      <BackButtonContainer>
        <ActionButton
          variant="link-button"
          buttonText={t(TranslationKeys.common_back_to_overview)}
          onClickAction={onBack}
          back={true}
        />
      </BackButtonContainer>
      <ContentContainer>
        <ArticleDetailsContainer>
          <NewsDetails
            countryIsoCode={countryIsoCode}
            selectedArticle={selectedArticle}
            handleBackToOverview={onBack}
          />
        </ArticleDetailsContainer>
        <MoreArticlesContainer>
          <MoreNewsList
            countryIsoCode={countryIsoCode}
            articles={relatedArticles}
            onReadMore={onReadMore}
          />
        </MoreArticlesContainer>
      </ContentContainer>
    </NewsPreviewContainer>
  );
};

export default NewsPreview;
